module.exports = __webpack_public_path__ + "static/media/industries_banner2.2839ec4a.png";